import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-history',
  templateUrl: './logo-history.component.html',
  styleUrls: ['./logo-history.component.css'],
  imports: [],
})
export class LogoHistoryComponent {}
